export class SafeLocalStorage {
    static getItem(key: string): string | null {
        try {
            return localStorage.getItem(key)
        } catch (error) {
            console.warn(`Failed to read from localStorage. Key: "${key}"`, error)
            return null
        }
    }

    static setItem(key: string, value: string): void {
        try {
            localStorage.setItem(key, value)
        } catch (error) {
            console.warn(`Failed to write to localStorage. Key: "${key}", value: "${value}"`, error)
        }
    }

    static removeItem(key: string): void {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            console.warn(`Failed to remove item from localStorage. Key: "${key}"`, error)
        }
    }
}
